import * as React from "react";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import {
  GridRowModes,
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useMutation, useQueryClient } from "react-query";
import { updateMaterialInwardStatus } from "../../container/AdminDashboard/mutations/TransactionsMutation";
import { handleToastMsg } from "./Toast";

export default function EditableTable({ tableData }) {
  console.log({ tableData });
  const [rows, setRows] = React.useState(tableData);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const { mutate } = useMutation(updateMaterialInwardStatus);
  const queryClient = useQueryClient();

  React.useEffect(() => {
    setRows(tableData);
  }, [tableData]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id, row) => () => {
    console.log({ id, row, rows }, "handleSaveClick");
    console.log({ rowModesModel });
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    mutate(
      {
        id: newRow.id,
        invoice_num: newRow.invoiceNum,
      },
      {
        onSuccess: (res) => {
          queryClient.invalidateQueries("material-inward-transactions");
          handleToastMsg("Data updated successfully", "success");
        },
        onError: (err) => {
          handleToastMsg("Error", "error");
        },
      }
    );
    const updatedRow = { ...newRow, isNew: false };
    console.log({ updatedRow }, "updated");

    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const ImageCellRenderer = (params) => (
    <img
      src={params.value} // Assumes that `params.value` contains the base64 image data
      alt={`${params.id}`}
      style={{ width: "100%", height: "auto" }}
    />
  );

  console.log("hiii")

  const columns = [
    {
      field: "image",
      headerName: "Image",
      type: "image",
      renderCell: ImageCellRenderer,
      width: 150,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "invoiceNum",
      headerName: "Invoice Number",
      type: "text",
      width: 150,
      align: "left",
      headerAlign: "left",
      editable: true,
    },
    {
      field: "type",
      headerName: "Type",
      type: "text",
      width: 150,
      align: "left",
    },
    {
      field: "inTime",
      headerName: "In Time",
      type: "time",
      width: 180,
    },
    {
      field: "outTime",
      headerName: "Out Time",
      type: "time",
      width: 180,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: (props) => {
        const isInEditMode =
          rowModesModel[props.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(props.id, props.row)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(props.id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(props.id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  return (
    <Box
      sx={{
        height: 500,
        width: "100%",
        "& .actions": {
          color: "text.secondary",
        },
        "& .textPrimary": {
          color: "text.primary",
        },
        padding: "20px 0",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
      />
    </Box>
  );
}
